$(document).ready(function() {

// SMOOTH SCROLL
$(".sliding-link").click(function(e) {
		e.preventDefault();
		var aid = $(this).attr("href");
		$('html,body').animate({scrollTop: $(aid).offset().top},'slow');
});

	// REPLACE ALL SVG IMAGES WITH INLINE SVG
	jQuery('img.svg').each(function(){
		var $img = jQuery(this);
		var imgID = $img.attr('id');
		var imgClass = $img.attr('class');
		var imgURL = $img.attr('src');
		jQuery.get(imgURL, function(data) {
			var $svg = jQuery(data).find('svg');
			if(typeof imgID !== 'undefined') {
				$svg = $svg.attr('id', imgID);
			}
			if(typeof imgClass !== 'undefined') {
				$svg = $svg.attr('class', imgClass+' replaced-svg');
			}
			$svg = $svg.removeAttr('xmlns:a');
			$img.replaceWith($svg);
		}, 'xml');
	});

	// RENDER AGAIN SVGS THAT WERE INSERTED AFTER THE PAGE LOADED
	setTimeout(function(){
		jQuery('img.svg').each(function(){
			var $img = jQuery(this);
			var imgID = $img.attr('id');
			var imgClass = $img.attr('class');
			var imgURL = $img.attr('src');
			jQuery.get(imgURL, function(data) {
				var $svg = jQuery(data).find('svg');
				if(typeof imgID !== 'undefined') {
					$svg = $svg.attr('id', imgID);
				}
				if(typeof imgClass !== 'undefined') {
					$svg = $svg.attr('class', imgClass+' replaced-svg');
				}
				$svg = $svg.removeAttr('xmlns:a');
				$img.replaceWith($svg);
			}, 'xml');
		});
	}, 200);

function afterReveal( el ) { 
	el.addEventListener('animationstart', function( event ) { 
	$('.wow').each(function(){ $(this).css('opacity',1); 	
		}); 	
	}); 
}
new WOW({ callback: afterReveal }).init();


// FANCYBOX
$('[data-fancybox]').fancybox({
  toolbar : true,
  smallBtn : false,
  arrows: true,
  touch: false,
  autoFocus: false,
  buttons : [
    'close'
  ],
  animationEffect : "zoom-in-out",
  transitionEffect : "circular",
}); // END FANCYBOX

/*------------------------------------------------------
--------------------------------------------------------
  ## SEARCH POP UP
--------------------------------------------------------
------------------------------------------------------*/

$('#open-search').click(function() {
	$.fancybox.open( $('.search-box') );
});


/*------------------------------------------------------
--------------------------------------------------------
  ## MOBILE MENU
--------------------------------------------------------
------------------------------------------------------*/
$('#open-mobile-menu').click(function(){
	$('body').addClass('menu-open');
	setTimeout(function(){
		$('#mobile-menu .block').addClass('active');
	}, 300);
});

$('#close-mobile-menu, #mobile-menu .bg').click(function(){
	$('#mobile-menu .block').removeClass('active');
	setTimeout(function(){
		$('body').removeClass('menu-open');
	}, 300);
});


//GET RETURN PAGE CHALLENGE > FORM CONTACT
var url_string = window.location.href;
var url = new URL(url_string);
var x = url.pathname;

if(x != "/challenge"){
	console.log("here");
	if(Cookies.get('contact_djss') == 1){
			document.cookie = 'contact_djss=0; path=/;';
			$.fancybox.open($("#popup-success"));
}
		else{
			console.log("no cookie");
	 }
}


});

$( document ).ready(function() {
	if(document.cookie.indexOf('accept_cookie_djss') < 0){
		console.log("accept cookie yes");

		$.fancybox.open($("#us-popup"));

		$('#us-popup .accept').click(function(){

		$('#us-popup').fadeOut();

		// 5 day cookie
		var date = new Date();
		date.setTime(date.getTime() + (5*24*60*60*1000));
		expires = "; expires=" + date.toUTCString();
		document.cookie = "accept_cookie_djss=1" + expires + "; path=/";

		});
	}
});